
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        uraian: "",
        deskripsi: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;
      percentage = totals.a > 0 ? ((totals.b / totals.a) * 1000).toFixed(0) : 0;

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Jumlah Cadangan Pangan (Ton)", width: "12%" },
                { label: "Target Cadangan Pangan (Ton)" },
                { label: "Capaian (%)" },
                { label: "Program", width: "15%" },
                { label: "Kegiatan", width: "15%" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage", "uraian", "deskripsi"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: false,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Cadangan Pangan (Ton)",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Target Cadangan Pangan (Ton)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(0) : 0,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Stok Beras Awal Tahun (Ton)", width: "12%" },
                { label: "Penambahan (Pengadaan/Bantuan)", width: "12%" },
                { label: "Penyaluran (Bencana/Stabilisasi)", width: "12%" },
                { label: "Stok Beras Akhir Tahun (Ton)", width: "12%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "c", "d"],
            sumColumns: ["a", "b", "c", "d"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Stok Beras Awal Tahun (Ton)",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Penambahan (Pengadaan/Bantuan)",
                    type: "text",
                  },
                  {
                    key: "c",
                    label: "Penyaluran (Bencana/Stabilisasi)",
                    type: "text",
                  },
                  {
                    key: "d",
                    label: "Stok Beras Akhir Tahun (Ton)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_KETAPANG + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_KETAPANG + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Ketahanan Pangan</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_KETAPANG + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_KETAPANG + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_KETAPANG + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.uraian = data.uraian;
      this.form.deskripsi = data.deskripsi;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
  },
};
